import React  from 'react';
import Modal from 'react-modal';
import { withTranslation } from "react-i18next";

const LoadingModal = ( { show, text, t } ) => {
  const closeModal = () => {};

  return (
    <Modal
      isOpen={ show }
      onRequestClose={ closeModal }
      contentLabel=""
      ariaHideApp={ false }
      className="loading-modal"
    >
      <div className="page-loader">
        <div className="loading">
          <div className="loading-spin">&nbsp;</div>
        </div>
        <div className={'loading-text'}>{ text || t('messages.please_wait') }</div>
      </div>
    </Modal>
  );
};

export default withTranslation()(LoadingModal);
